import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Grid, Box, Container } from '@mui/material';
import { Add } from 'iconsax-react';
import { ActionCard } from '../../../components/admin/cards/ActionCard';
import { PageHeader } from '../../../components/common/header/PageHeader';
import { SearchField } from '../../../components/common/inputs/SearchField';
import { ClientTable } from './table/ClientTable';
import { useAppDispatch, useAppSelector } from '@application/store/useStore';
import { useEffect, useState } from 'react';
import { getClientsAsync } from '@application/features/clients/clientThunk';
export const Clients = () => {
    const { clients } = useAppSelector((state) => state.client);
    const [searchQuery, setSearchQuery] = useState('');
    const dispatch = useAppDispatch();
    useEffect(() => {
        dispatch(getClientsAsync());
    }, [dispatch]);
    const handleSearchChange = (query) => {
        setSearchQuery(query);
    };
    return (_jsxs(_Fragment, { children: [_jsx(PageHeader, { title: 'Clients' }), _jsx(Container, { children: _jsxs(Grid, { container: true, spacing: 3, children: [_jsx(Grid, { item: true, md: 3, sm: 12, xs: 12, children: _jsxs(Box, { sx: {
                                    mt: { xs: 0, sm: 1, md: 10 },
                                    display: 'flex',
                                    flexDirection: {
                                        xs: 'column',
                                        sm: 'row',
                                        md: 'column',
                                        lg: 'column'
                                    },
                                    gap: 2
                                }, children: [_jsx(Box, { width: '100%', children: _jsx(ActionCard, { subtitle: 'Add new client ', color: 'yellow', icon: _jsx(Add, { style: { color: 'white' } }), to: '/clients-add-new' }) }), _jsx(Box, { width: '100%', children: _jsx(ActionCard, { subtitle: `All clients (${clients?.length})`, color: 'primary', to: '' }) })] }) }), _jsxs(Grid, { item: true, md: 9, sm: 12, xs: 12, children: [_jsx(SearchField, { onSearchChange: handleSearchChange, searchQuery: searchQuery, bgColor: 'white', mb: 2, fullWidth: true, placeholderColor: '#B1B1B1', placeholder: 'Search clients' }), _jsx(ClientTable, { searchQuery: searchQuery })] })] }) })] }));
};
